import { cn } from "@moe/priv/utils";
import { AuthForm } from "@web/components/AuthForm";
import { useAppContext } from "@web/route-services/root/AppContext";

interface Props {
  actionMessage?: string;
  className?: string;
}

export function UnAuthedMessage({ actionMessage, className }: Props) {
  const { createModal } = useAppContext();
  return (
    <>
      <div className={cn("flex h-full w-full flex-col items-center justify-center px-4 py-10  leading-6", className)}>
        <p className="text-tx-primary text-base font-semibold">
          Please{" "}
          <span
            onClick={() => {
              createModal({
                content: <AuthForm formKind="signin" />
              });
            }}
            className="text-action-primary cursor-pointer text-lg font-bold"
          >
            Log in
          </span>{" "}
          or{" "}
          <span
            onClick={() => {
              createModal({
                content: <AuthForm formKind="signup" />
              });
            }}
            className="text-action-primary cursor-pointer text-lg font-bold"
          >
            Sign Up
          </span>{" "}
          to {actionMessage ? actionMessage : "view this page!"}
        </p>
        <p className="text-tx-tertiary select-none font-bold">{`⊂(・﹏・⊂)`}</p>
      </div>
    </>
  );
}
